import { api } from '@/lib/api';
import type { PermissionCapabilityRow } from '@/types/api';

export const permissionsApi = {
  capabilities: () => api.get<string[]>('/permissions/capabilities'),
  userPermissions: (userId: string) => api.get<PermissionCapabilityRow[]>(`/permissions/${userId}`),
  upsertUserPermissions: (userId: string, permissions: PermissionCapabilityRow[]) =>
    api.patch<PermissionCapabilityRow[]>(`/permissions/${userId}`, {
      permissions: permissions.map((item) => ({ capability: item.capability, allowed: item.allowed }))
    })
};
